import { Auth } from 'aws-amplify'
import { useRouter } from 'next/router'
import React, { Dispatch, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { Meta } from 'src/layout/Meta'
import { accept } from 'src/pages/api/vendor/invitationApi'
import { showToast } from 'src/store/actions/toastAction'
import { Main } from 'src/templates/Main'
import { v4 as uuidv4 } from 'uuid'

import { SignUpBottom } from './SignUpBottom'
import { VendorInvitationSignUpForm, VendorInvitationSignUpFormData } from './VendorInvitationSignUpForm'
import { VendorTeaser } from './VendorTeaser'

type company = {
  companyName: string
  companyType: string
  companySize: string
}

type Props = {
  // terms: ITermsConditionsEntity
  // privacyPolicy: IPrivacyPolicyEntity
  // // newsletterCategories: INewsletterCategoryEntity[]
  company: company
  registered: boolean
  token: string
  email: string
  first_name: string
  last_name: string | null
  job_title: string
}

const VendorInvitation: React.FC<Props> = ({ registered, token, email, first_name, last_name, job_title, company }) => {
  const router = useRouter()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()
  const [isProgressing, setIsProgressing] = useState(false)
  const { status } = useAuthenticated()

  const acceptJoin = async () => {
    try {
      const res = await accept(token as string)
      if (res.status === 200) {
        dispatch(showToast('Verification completed', 'info'))

        if (status === 'authenticated') {
          router.push('/')
        } else {
          router.push('/signin')
        }
      } else {
        dispatch(showToast('Validation failed', 'error'))
      }
    } catch (error) {
      dispatch(showToast('Validation failed', 'error'))
    }
  }

  const onSubmit = async (formData: VendorInvitationSignUpFormData) => {
    setIsProgressing(true)

    const validationData = {
      first_name,
      last_name,
      company_name: company.companyName,
      company_size: company.companySize,
      company_type: company.companyType,
      // country_id: formData.countryId,
      job_title,
      invitation_token: token,
    }

    try {
      await Auth.signUp({
        username: uuidv4(),
        password: formData.password,
        attributes: {
          email: formData.email.toLocaleLowerCase(),
        },
        validationData,
        autoSignIn: {
          enabled: true,
          validationData,
        },
      })

      setIsProgressing(false)
      dispatch(showToast('Thanks for registering! We have sent a verification email. Please check your inbox.', 'info'))
      setTimeout(() => {
        router.push('/')
      }, 20000)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      setIsProgressing(false)
      dispatch(showToast(`Error signing up: ${error.message}`, 'error'))
    }
  }

  const title = 'Vendor SignUp'
  const description = 'Enter your email address and we will send you a link to reset your password.'

  const meta = <Meta title={title} description={description} url="/forgot" />

  return (
    <Main meta={meta}>
      <div id="mainContainer" className="mainContianer h-full w-full">
        <div className="w-full h-full">
          <div className="w-full h-full">
            <div className="flex md:flex-row flex-col h-fit min-h-full">
              <VendorTeaser />
              <div className="flex md:max-w-[710px] w-full mr-[20px] h-fit">
                <div className="w-full mb-[3rem] md:ml-[154px] mt-[86px] pl-[20px] pr-[20px]">
                  <div className="flex flex-col w-full">
                    <div className="text-[18px] font-bold font-secondary text-shade mt-4">Step 2 of 2</div>
                    <h1 className="text-[30px] font-bold font-secondary text-[#011753] mt-4">
                      Request a <span className="text-navybright">Vendor Account</span>
                    </h1>
                  </div>
                  <div className="w-full h-fit">
                    <div className="flex flex-col mt-[24px]">
                      <p className="text-[1.5rem]">
                        Thank you for registering your interest in a LTH Vendor Account. Please create your log-in
                        details below.
                      </p>
                      <div className="w-full h-fit">
                        {!registered && (
                          <VendorInvitationSignUpForm
                            email={email}
                            isProgressing={isProgressing}
                            onSubmit={onSubmit}
                            first_name={first_name}
                            last_name={last_name}
                            job_title={job_title}
                          />
                        )}

                        {registered && (
                          <button
                            className="text-white font-secondary text-[14px] font-bold text-center px-[25px] mt-[60px] bg-navybright rounded-[50px] w-auto py-[10px] cursor-pointer"
                            onClick={() => acceptJoin()}
                          >
                            Verify and Join
                          </button>
                        )}
                      </div>
                      <div className="mt-[52px]">
                        <SignUpBottom currentStep={2} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Main>
  )
}

export default VendorInvitation
